import React from 'react'
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Category,
  Legend,
  Tooltip,
  DataLabel,
  BarSeries,
  AxisModel,
} from '@syncfusion/ej2-react-charts'

type Data = {
  x: string
  y: number
  color?: string
}

type RangeSetting = {
  label?: string
  start: number
  end: number
  colors: string[]
}

type BarChartProps = {
  title: string
  isTransposed: boolean
  data: Data[]
  primaryXAxis?: AxisModel
  primaryYAxis?: AxisModel
  onClick?: () => void
  barRadius?: number
  borderWidth?: number
  height?: string
  width?: string
  rangeColorSettings?: RangeSetting[]
}

function BarChart({
  title,
  isTransposed,
  data,
  primaryXAxis,
  primaryYAxis,
  onClick,
  barRadius = 8,
  borderWidth = 1,
  height,
  width,
  rangeColorSettings = [],
}: BarChartProps): React.ReactElement {
  const defaultprimaryYAxis: AxisModel = {
    minimum: 2.0,
    maximum: 4.0,
    interval: 0.2,
  }
  const defaultprimaryXAxis: AxisModel = { valueType: 'Category' }
  return (
    <ChartComponent
      id={title}
      primaryXAxis={primaryXAxis ?? defaultprimaryXAxis}
      primaryYAxis={primaryYAxis ?? defaultprimaryYAxis}
      tooltip={{ enable: true }}
      isTransposed={isTransposed}
      legendSettings={{
        visible: true,
        position: 'Top',
        alignment: 'Center',
        height: height ?? '200',
      }}
      chartArea={{ border: { width: borderWidth } }}
      height={height ?? '250'}
      width={width ?? '600'}
      pointClick={onClick}
    >
      <Inject services={[BarSeries, Legend, Tooltip, DataLabel, Category]} />
      <SeriesCollectionDirective>
        <SeriesDirective
          type="Bar"
          dataSource={data}
          name=""
          xName="x"
          yName="y"
          pointColorMapping="color"
          legendShape="Rectangle"
          columnWidth={0.93}
          cornerRadius={{
            topLeft: barRadius,
            topRight: barRadius,
            bottomLeft: barRadius,
            bottomRight: barRadius,
          }}
          width={200}
        />
      </SeriesCollectionDirective>
    </ChartComponent>
  )
}
export default BarChart
